import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from "pinia"


// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import axios from 'axios';


const vuetify = createVuetify({
    components,
    directives,
})


// 401만 로그인 페이지로 리다이렉트 (모든 에러에서 리다이렉트하면 로그인 실패 시에도 튕겨버림)
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('auth');
            localStorage.removeItem('authExpMin');
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

createApp(App).use(createPinia()).use(router).use(vuetify).mount('#app')
